import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const ConfirmedContent = () => {
  return (
    <Stack alignItems={'center'} p={8} gap={2}>
      <Typography
        variant="h4"
        color={'secondary'}
        display={'flex'}
        gap={1}
        alignItems={'center'}
      >
        <CheckCircleOutline />
        Your sample request was submitted!
      </Typography>

      <Typography>
        Shortly, you will receive an email with a recap of your request.
      </Typography>
      <Typography variant="caption" textAlign={'center'} color="textSecondary">
        Keep exploring UX-Beauty while our team is currently reviewing your
        request. If you need any further assistance, feel free to reach out to
        your usual sales contacts.
      </Typography>
      <Button variant="contained" component={Link} to={'/ingredients/search'}>
        Continue exploring
      </Button>
    </Stack>
  );
};
